import {Dispatch, FunctionComponent, SetStateAction, useCallback, useMemo} from 'react';

import HanTabs, { HanTab } from '../../../../utils/han-tabs-components/HanTabs';
import UniversityProgram from '../university-program/UniversityProgram';
import University from '../../../../../networking/models/University';
import FormQuestion from '../../../../../networking/models/FormQuestion';
import UniversityExperiences from '../university-experiences/UniversityExperiences';
import UniversityGeneral from '../university-general/UniversityGeneral';
import {UniversityParts} from '../../../../query/University/Query';
import {UniversitySubjectsResponse} from '../../../../../networking/responses/University';

interface Props {
    university: University;
    subjects: UniversitySubjectsResponse;
    parts: UniversityParts;
    universityWithCosts: University;

    filters: any;
    setFilters: Dispatch<SetStateAction<any>>;

    onSubjectPageChange: (page: number) => void;
}

const UniversityDetailContent: FunctionComponent<Props> = (props) => {
    const questions = useMemo<FormQuestion[]>(() => {
        return props.parts.program.reduce<FormQuestion[]>((prevValue, currentValue) => {
            return [...prevValue, ...currentValue.active_questions];
        }, [])
    },[props.parts.program]);

    const onSubjectSearch = useCallback((query: string) => {
        props.setFilters((p: any) => ({ ...p, search: query }));
    }, []);

    const onSubjectsOrderBy = useCallback((column: string, direction?: string) => {
        return props.setFilters((p: any) => ({ ...p, order_by: column, direction  }));
    }, []);

    return (
        <>
            <HanTabs
                title={props.university.name}
                breadcrumbs={
                    [
                        { name: "Home", url: "/" },
                        { name: "Universities", url: "/universities" },
                        { name: props.university.name, url: `/universities/${props.university.id}` }
                    ]
                }
            >
                <HanTab title={'General'}>
                    <UniversityGeneral university={props.university} formParts={props.universityWithCosts} />
                </HanTab>

                {/*<HanTab title={'Services'}>*/}
                {/*    <UniversityServices university={props.university} formParts={props.parts.services} />*/}
                {/*</HanTab>*/}

                <HanTab title={'Program'}>
                    <UniversityProgram
                        formQuestions={questions}
                        subjects={props.subjects}
                        onSubjectSearch={onSubjectSearch}
                        onSubjectsOrderBy={onSubjectsOrderBy}
                        onPageChange={props.onSubjectPageChange} />
                </HanTab>

                <HanTab title={'Experiences'}>
                    <UniversityExperiences formParts={props.parts.experiences} />
                </HanTab>
            </HanTabs>
        </>
    );
}

export default UniversityDetailContent;
